<template>
  <div class="h-full">

    <div v-if="this.$page.props.user.current_team">
      <!-- Statistics Cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 p-4 gap-4">
        <div
            class="bg-gradient-to-r from-green-300 to-blue-300 shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-blue-500 text-white font-medium group">
          <div
              class="flex justify-center items-center w-14 h-14  bg-white  rounded-full transition-all duration-300 transform group-hover:rotate-12">

            <EmojiHappyIcon
                class="stroke-current text-pink-400 w-10 h-10"></EmojiHappyIcon>

          </div>
          <div class="text-right font-semibold text-black">
            <p class="text-2xl">{{ metrics.team }}</p>
            <p>Team Name</p>
          </div>
        </div>
        <div
            class="bg-gradient-to-r from-green-300 to-blue-300 shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-blue-500 text-white font-medium group">
          <div
              class="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">

            <StarIcon
                class="stroke-current text-yellow-400 w-10 h-10"></StarIcon>


          </div>
          <div class="text-right font-semibold text-black">
            <p class="text-2xl">{{ metrics.average_rate }}</p>
            <p>Average Rate</p>
          </div>
        </div>
        <div
            class="bg-gradient-to-r from-green-300 to-blue-300 shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-blue-500 text-white font-medium group">
          <div
              class="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">

            <UserGroupIcon
                class="stroke-current text-purple-400 w-10 h-10"></UserGroupIcon>
          </div>
          <div class="text-right font-semibold text-black">
            <p class="text-2xl">{{ metrics.total_boards }}</p>
            <p>Boards</p>
          </div>
        </div>

        <div
            class="bg-gradient-to-r from-green-300 to-blue-300 shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-blue-500 text-white font-medium group">
          <div
              class="flex justify-center items-center w-14 h-14  bg-white  rounded-full transition-all duration-300 transform group-hover:rotate-12">
            <LightBulbIcon
                class="stroke-current text-blue-400 w-10 h-10"></LightBulbIcon>
          </div>
          <div class="text-right font-semibold text-black">
            <p class="text-2xl">{{ metrics.total_actions }}</p>
            <p>Actions</p>
          </div>
        </div>
      </div>
      <!-- ./Statistics Cards -->

      <div class="grid grid-cols-1 lg:grid-cols-2 p-4 gap-4">

        <!-- Social Traffic -->
        <div
            class="relative flex flex-col min-w-0 mb-4 lg:mb-0 break-words bg-gray-50 dark:bg-gray-800 w-full shadow-lg rounded">
          <div class="rounded-t mb-0 px-0 border-0">
            <div id="chart">

            </div>
          </div>
        </div>
        <!-- ./Social Traffic -->

        <!-- Recent Activities -->
        <div class="relative flex flex-col min-w-0 break-words bg-gray-50 dark:bg-gray-800 w-full shadow-lg rounded">
          <div class="rounded-t mb-0 px-0 border-0">
            <div class="flex flex-wrap items-center px-4 py-2">
              <div class="relative w-full max-w-full flex-grow flex-1">
                <h3 class="font-semibold text-base text-gray-900 dark:text-gray-50">Recent Actions
                  <span
                      class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
    {{ metrics.actions.length }}
  </span></h3>
              </div>
              <!--            <div class="relative w-full max-w-full flex-grow flex-1 text-right">-->
              <!--              <button-->
              <!--                  @click="this.$inertia.visit( route('retrospective.room.summary'));"-->
              <!--                  class="bg-blue-500 dark:bg-gray-100 text-white active:bg-blue-600 dark:text-gray-800 dark:active:text-gray-700 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
              <!--                  type="button">See all-->
              <!--              </button>-->
              <!--            </div>-->
            </div>
            <div class="block w-full">
              <div
                  class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Action(s)
              </div>
              <ul class="my-1">
                <li class="truncate flex px-4" v-for="action in metrics.actions">
                  <div class="w-9 h-9  flex-shrink-0 my-2 mr-3">
                    <input aria-describedby="comments-description" :checked="action.is_done === true" name="comments"
                           type="checkbox" @change="changeDone($event,action)"
                           class="focus:ring-yellow-500 h-8 w-8 text-yellow-600 border-gray-300 rounded"
                    />
                  </div>
                  <div
                      class="flex-grow flex items-center border-b border-gray-100 dark:border-gray-400 text-sm text-gray-600 dark:text-gray-100 py-2">
                    <div class="flex-grow truncate flex justify-between items-center">
                      <div class="self-center">
                        {{ action.action }}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- ./Recent Activities -->
      </div>

      <!-- Client Table -->
      <div class="mt-4 mx-4">
        <div
            class="relative flex flex-col min-w-0 mb-4 lg:mb-0 break-words bg-gray-50 dark:bg-gray-800 w-full shadow-lg rounded">

          <div class="flex flex-wrap items-center px-4 py-2">
            <div class="relative w-full max-w-full flex-grow flex-1">
              <h3 class="font-semibold text-base text-gray-900 dark:text-gray-50">Boards History <span
                  class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
    {{ metrics.boards.length }}
  </span></h3>
            </div>
            <!--          <div class="relative w-full max-w-full flex-grow flex-1 text-right">-->
            <!--            <button-->
            <!--                class="bg-blue-500 dark:bg-gray-100 text-white active:bg-blue-600 dark:text-gray-800 dark:active:text-gray-700 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
            <!--                type="button">See all-->
            <!--            </button>-->
            <!--          </div>-->
          </div>
          <div class="block w-full overflow-x-auto">
            <table class="items-center w-full bg-transparent border-collapse">
              <thead>
              <tr>
                <th class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Name
                </th>
                <th class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Rate
                </th>
                <th class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Status
                </th>
                <th class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Date
                </th>
                <th class="px-4 bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px"></th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-gray-700 dark:text-gray-100" v-for="board in metrics.boards">
                <th class="truncate border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ board.room_name }}
                </th>
                <td class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                <span
                    class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
         {{ board.rate ? board.rate : 'N/A' }}
  </span>
                </td>
                <td class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                     <span
                         class="ml-2 flex-shrink-0 inline-block px-2 py-1 text-green-800 text-xs font-bold bg-green-100 rounded-full">
                      {{ board.status }}
                    </span>
                </td>
                <td class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ board.created_at }} (UTC)
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ./Client Table -->
    </div>
    <div v-else>
      <no-team-alert></no-team-alert>
    </div>

  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import {onMounted, ref} from "vue";
import ApexCharts from "apexcharts";
import {
  StarIcon,
  EmojiHappyIcon,
  LightBulbIcon,
  UserGroupIcon,
} from "@heroicons/vue/outline";
import {message} from "ant-design-vue";
import NoTeamAlert from "@/Pages/Retrospective/Components/NoTeamAlert";

export default {
  props: [],
  data() {
    return {};
  },
  mounted() {

  },
  created() {
  },
  setup() {


    const metrics = ref({
      average_rate: 0,
      total_boards: 0,
      team: '',
      total_actions: 0,
      boards: [],
      actions: [],
      rate_chart: {
        categories: [],
        data: []
      }

    });

    const chartRef = ref();

    function getMetrics() {
      axios
          .get(route("retrospective.room.metrics"))
          .then((response) => {
            metrics.value = response.data;

            let options = {
              chart: {
                type: 'line'
              },
              series: [{
                name: 'rate',
                data: metrics.value.rate_chart.data
              }],
              xaxis: {
                categories: metrics.value.rate_chart.categories
              }
            }
            chartRef.value.updateSeries([{
              name: 'rate',
              data: metrics.value.rate_chart.data
            }])
          })
          .catch((error) => {
            console.log(error);
          });
    }

    const changeDone = (e, action) => {
      axios.patch(route("retrospective.action.board.mark", action.id),
          {is_done: !action.is_done})
          .then((response) => {
            message.success("Your action is updated");
          })
          .catch((error) => {
            message.error("We cannot update your action");
          });
    };

    onMounted(async () => {
      const options = {
        chart: {
          type: 'line'
        },
        series: [],
        xaxis: {
          categories: metrics.value.rate_chart.categories
        }
      }

      const chart = new ApexCharts(document.querySelector("#chart"), options);
      chartRef.value = chart;
      await chart.render();

      await getMetrics();
    })
    return {
      changeDone,
      metrics
    };
  },
  components: {
    NoTeamAlert,
    LightBulbIcon,
    EmojiHappyIcon,
    StarIcon,
    UserGroupIcon,
    AppLayout,
  },
};
</script>
